<template>
  <div>
    <div v-if="userStatusAlertMessage" class="status-message">
      {{ $t(userStatusAlertMessage) }}
    </div>
    <ul class="glnavi tab_none sp_none">
      <li v-for="item in links" :key="item.name">
        <a v-if="item.name == 'wash-request'" href="/wash-request" class="glnavi_btn"
          :class="{ glnavi_btn_on: active === item.name, 'glnavi_btn_disabled': isWashRequestDisabled }" >
          {{ $t('deliveryRequest') }}
        </a>
        <router-link v-else :to="{ name: item.name }" class="glnavi_btn"
          :class="{ glnavi_btn_on: active === item.name }">
          {{ $t(item.label) }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from 'vue';
import { useStore } from '@/hook/useStore';
import {
  STATUS_ENABLED,
  STATUS_PENDING_REVIEW,
  STATUS_REJECTED,
} from '@/consts/lov';

export default defineComponent({
  props: {
    active: {
      type: String,
      default: 'wash-request'
    }
  },
  setup(props) {
    const store = useStore();
    const userStatus = ref(0);

    const links = [
      {
        name: 'wash-request',
        label: 'deliveryRequest',
      },
      {
        name: 'wash-request-currents',
        label: 'changeOrCancel',
      },
      {
        name: 'wash-history',
        label: 'usageHistory',
      },
      {
        name: 'profile',
        label: 'customerInfo',
      },
      {
        name: 'plan',
        label: 'changePlan',
      },
    ];

    async function fetchUser() {
      const me = await store.dispatch('user/getMe');
      userStatus.value = me.status;
    }

    onMounted(async () => {
      await fetchUser();
    });

    const userStatusAlertMessage = computed(() => {
      if (userStatus.value === STATUS_PENDING_REVIEW) {
        return 'messages.pendingReview';
      }
      if (userStatus.value === STATUS_REJECTED) {
        return 'messages.rejected';
      }
      return '';
    });

    const isWashRequestDisabled = computed(() => {
      return userStatus.value !== STATUS_ENABLED;
    });

    return {
      links,
      userStatusAlertMessage,
      isWashRequestDisabled,
    };
  }
});
</script>

<style scoped>
.status-message {
  color: red;
  background-color: #ffeeee;
  padding: 10px;
  border: 1px solid red;
  margin-bottom: 10px;
  text-align: center;
}

.glnavi_btn_disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
